<div class="loader" [ngStyle]="{'display': isLoader ? '' : 'none'}">
    <div class="spinner" id="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
    </div>
</div>

<app-layout>
    <router-outlet></router-outlet>
</app-layout>

